import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class taskCapacityBarsCtrl implements IController {

  currentLoad: any;
  isColumn: boolean;

  private weightUnit: any;
  private volumeUnit: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {}

  $onInit() {
    this.weightUnit = this.splitService.getWeightUnit();
    this.volumeUnit = this.splitService.getVolumeUnit();
  }

}
angular
  .module('bringoz.admin.tasks')
  .component('taskCapacityBars', {
    bindings: {
      currentLoad: '<',
      isColumn: '<?'
    },
    template: require('./task-capacity-bars.html').default,
    controller: taskCapacityBarsCtrl
  });
